var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon21(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1662 8.0013H1.2488C0.688457 8.0013 0.207031 7.51901 0.207031 6.96556C0.207031 6.41211 0.688457 5.92191 1.2488 5.92191H20.2531C20.8134 5.92191 21.2869 6.4042 21.2869 6.96556C21.208 7.52692 20.7266 8.0013 20.1662 8.0013Z",
    fill: "url(#paint0_linear_403_215)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1658 8.0013H27.1902C26.6298 8.0013 26.1484 7.51901 26.1484 6.96556C26.1484 6.41211 26.6298 5.92191 27.1902 5.92191H37.1658C37.7262 5.92191 38.2076 6.4042 38.2076 6.96556C38.1287 7.52692 37.6473 8.0013 37.1658 8.0013Z",
    fill: "url(#paint1_linear_403_215)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1918 15.0381H15.2195C14.6592 15.0381 14.1777 14.5558 14.1777 13.9944V1.03574C14.1777 0.474384 14.6592 0 15.2195 0C15.7798 0 16.2534 0.482291 16.2534 1.03574V13.0298H26.1501V1.03574C26.1501 0.474384 26.6315 0 27.1918 0C27.7522 0 28.2257 0.482291 28.2257 1.03574V13.9944C28.1468 14.5558 27.6654 15.0381 27.1918 15.0381Z",
    fill: "url(#paint2_linear_403_215)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.177 25.0397H7.15301C6.59267 25.0397 6.11914 24.5574 6.11914 24.004C6.11914 23.4505 6.60056 22.9603 7.15301 22.9603H14.177C14.7373 22.9603 15.2188 23.4426 15.2188 24.004C15.2188 24.5653 14.7373 25.0397 14.177 25.0397Z",
    fill: "url(#paint3_linear_403_215)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2069 29.0404H7.23122C6.67088 29.0404 6.18945 28.5581 6.18945 27.9967C6.18945 27.4353 6.67088 26.9531 7.23122 26.9531H17.2069C17.7672 26.9531 18.2486 27.4353 18.2486 27.9967C18.2486 28.5581 17.6883 29.0404 17.2069 29.0404Z",
    fill: "url(#paint4_linear_403_215)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1936 35.9981H1.24099C0.680644 35.9981 0.199219 35.5158 0.199219 34.9544V1.04368C0.199219 0.482319 0.680644 0.00793457 1.24099 0.00793457H37.1659C37.7263 0.00793457 38.2077 0.490225 38.2077 1.04368V25.1188C38.2077 25.6802 37.7263 26.1545 37.1659 26.1545C36.6056 26.1545 36.1242 25.6722 36.1242 25.1188V2.00037H2.19593V33.9898H25.1857C25.746 33.9898 26.2274 34.4721 26.2274 35.0335C26.2274 35.5948 25.746 35.9901 25.1857 35.9901L25.1936 35.9981Z",
    fill: "url(#paint5_linear_403_215)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1325 47.9921C29.5031 47.9921 24.1602 42.6315 24.1602 35.998C24.1602 35.6739 24.1602 35.2785 24.2391 34.8753C24.4758 31.9183 25.8333 29.1194 28.0747 27.1191C30.3081 25.1187 33.1809 23.917 36.1404 23.917C36.464 23.917 36.8586 23.9169 37.2611 23.996C40.2127 24.2332 43.0066 25.5931 45.0033 27.8386C47 30.0761 48.1996 32.954 48.1996 35.9189C48.1207 42.6394 42.7698 48 36.1404 48L36.1325 47.9921ZM36.1325 25.9964C30.9395 25.9964 26.6304 29.9179 26.2358 35.1125C26.2358 35.4366 26.1569 35.7529 26.1569 35.9901C26.1569 41.5088 30.6238 45.9838 36.1325 45.9838C41.6412 45.9838 46.1161 41.5088 46.1161 35.9901C46.1161 30.7877 42.2016 26.4707 37.0164 26.0754C36.7797 25.9963 36.4561 25.9964 36.1404 25.9964H36.1325Z",
    fill: "url(#paint6_linear_403_215)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1289 37.9983H34.1355C33.5752 37.9983 33.0938 37.5161 33.0938 36.9626V28.0046C33.0938 27.4432 33.5752 26.9609 34.1355 26.9609H38.1289C38.6893 26.9609 39.1707 27.4432 39.1707 28.0046V37.0416C39.1707 37.5239 38.6893 37.9983 38.1289 37.9983ZM35.1694 35.998H37.1661V28.9613H35.1694V35.998Z",
    fill: "url(#paint7_linear_403_215)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1289 45.0351H34.1355C33.5752 45.0351 33.0938 44.5528 33.0938 43.9915V39.9908C33.0938 39.4294 33.5752 38.9471 34.1355 38.9471H38.1289C38.6893 38.9471 39.1707 39.4294 39.1707 39.9908V43.9915C39.1707 44.5528 38.6893 45.0351 38.1289 45.0351ZM35.1694 43.0348H37.1661V41.0345H35.1694V43.0348Z",
    fill: "url(#paint8_linear_403_215)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_403_215",
    x1: 10.747,
    y1: 5.92191,
    x2: 10.747,
    y2: 8.0013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_403_215",
    x1: 32.178,
    y1: 5.92191,
    x2: 32.178,
    y2: 8.0013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_403_215",
    x1: 21.2017,
    y1: 0,
    x2: 21.2017,
    y2: 15.0381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_403_215",
    x1: 10.669,
    y1: 22.9603,
    x2: 10.669,
    y2: 25.0397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_403_215",
    x1: 12.219,
    y1: 26.9531,
    x2: 12.219,
    y2: 29.0404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_403_215",
    x1: 19.2035,
    y1: 0.00793457,
    x2: 19.2035,
    y2: 35.9981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_403_215",
    x1: 36.1799,
    y1: 23.917,
    x2: 36.1799,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_403_215",
    x1: 36.1322,
    y1: 26.9609,
    x2: 36.1322,
    y2: 37.9983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_403_215",
    x1: 36.1322,
    y1: 38.9471,
    x2: 36.1322,
    y2: 45.0351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon21);
export default __webpack_public_path__ + "static/media/icon21.4a556f24b63657baff5add3592939649.svg";
export { ForwardRef as ReactComponent };